import { BaseCell } from "@similarweb/pro-logic-components";

import { StyledTrafficShareWrapper } from "app/pages/benchmark-tracker/components/Report/MetricElements/TableView/styles";
import type { CellSchema } from "app/pages/benchmark-tracker/components/Report/MetricElements/TableView/type";
import { MetricFormat } from "app/common/benchmark/types";
import { FORMATTERS, PERCENTAGE } from "app/common/benchmark/formatters";

export const CustomPercentageCell = ({ value, row }: CellSchema) => (
    <StyledTrafficShareWrapper isPrimary={row?.isPrimary}>
        <BaseCell>
            {FORMATTERS[MetricFormat.percent](+value)}
            {PERCENTAGE}
        </BaseCell>
    </StyledTrafficShareWrapper>
);
